export enum StripeStatus {
    WEB_HOOK_DISABLED = 'WEB_HOOK_DISABLED',
    WEB_HOOK_UNEXPECTED_FAIL = 'WEB_HOOK_UNEXPECTED_FAIL',
    STRIPE_KEY_FAIL = 'STRIPE_KEY_FAIL',
    STRIPE_PUBLIC_KEY_FAIL = 'STRIPE_PUBLIC_KEY_FAIL',
    SECRET_KEY_FAIL = 'SECRET_KEY_FAIL',
    STRIPE_INSTANCE_FAIL = 'STRIPE_INSTANCE_FAIL',
    STRIPE_SUCCESS = 'STRIPE_SUCCESS',
}
